export default "__VITE_ASSET__eW8M5Ue2__"